import { PushPin, PushPinOutlined } from "@mui/icons-material";
import { IconButton, SxProps, Theme } from "@mui/material";

export type PushPinButtonProps = {
    pinned: boolean | undefined;
    sx?: SxProps<Theme>;
    onClick: (() => void) | undefined;
}

export default function PushPinButton({
    pinned,
    sx,
    onClick
}: PushPinButtonProps): import("react").ReactNode {
    return (
        <IconButton
            sx={{
                margin: 1,
                marginLeft: -1,
                ...sx
            }}
            onClick={onClick}
        >
            {pinned
                ? (
                    <PushPin
                        //color="primary"
                        //fontSize="small"
                        sx={{
                            transform: "rotate(45deg)"
                        }} />
                )
                : (
                    <PushPinOutlined
                        //color="primary"
                        //fontSize="small"
                        sx={{
                            transform: "rotate(45deg)"
                        }} />
                )}
        </IconButton>
    );
}

